<template>
  <div class="grid grid-cols-12">
    <div class="col-span-3 p-8 pt-16 lg:p-12 lg:pl-14 bg-transaction-gradient
                space-y-12">
      <ValueInput v-model.trim="$v.form.sum.$model"
                  :label="$t('sum')"
                  :currency_id="!!form.account ? form.account.currency.id : null"
                  :class="{'--error':$v.form.sum.$error}">
        <template v-slot:errors="">
          <div class="error" v-if="$v.form.sum.$invalid">{{ $t('fieldRequired') }}</div>
        </template>
      </ValueInput>
      <ValueInput :label="$t('sum_to')"
                  v-model="$v.form.sum_to.$model"
                  :class="{'--error':$v.form.sum_to.$error}"
                  :currency_id="!!form.account_to ? form.account_to.currency.id : null">
        <template v-slot:errors="">
          <div class="error" v-if="$v.form.sum_to.$invalid">{{ $t('fieldRequired') }}</div>
        </template>
      </ValueInput>
    </div>
    <div class="col-span-9
                p-8 pt-16 lg:p-12 lg:pr-17
                grid grid-cols-2 col-gap-12 row-gap-12">
      <AccountsSelect v-model="form.account"
                      :label="$t('accountFrom')"
                      hidden-mode="keep-selected"
                      :accounts="accounts.data"
                      :account_groups="accounts_by_groups"
                      :grouped="accounts_by_groups.length > 1"
                      @open="open_form = true"/>
      <ValueInput v-if="!!form.account && !!form.account.commission"
                  :label="$t('commission')"
                  class="transfer-commission"
                  textAlign="left"
                  v-model="$v.form.fee.$model"
                  :currency_id="!!form.account ? form.account.currency.id : null">
      </ValueInput>
      <!--      <div v-else></div>-->
      <AccountsSelect v-model="form.account_to"
                      :label="$t('accountTo')"
                      hidden-mode="keep-selected"
                      :accounts="accountTransfer"
                      :account_groups="accountTransferGroups"
                      :grouped="accounts_by_groups.length > 1"
                      @open="open_form = true"/>
      <BaseSelect v-model="form.expenseCategory" v-if="transaction_options.category"
                  class="col-span-1"
                  :selectLabel="$t('categoryExpense')"
                  :options="expenses_by_groups"
                  :allow-empty="true"
                  :group-select="false"
                  :searchable="true"
                  :show-labels="false"
                  track-by="id"
                  label="title"
                  group-label="title"
                  group-values="childs">
      </BaseSelect>
      <BaseTextarea v-if="transaction_options['comment']"
                    class="col-span-2"
                    v-model="form.comment"
                    :label="$t('comment')"/>
      <BaseSelect v-if="transaction_options['tags']"
                  class="col-span-1"
                  v-model="form.tags"
                  :options="tags_list"
                  :selectLabel="$t('tags')"
                  label="title"
                  track-by="id"
                  :tag-placeholder="$t('tagCreateNew')"
                  :close-on-select="false"
                  :multiple="true"
                  :taggable="true"
                  @tag="addTag"
                  :show-labels="false">
        <template v-slot:noOptions>
          <div class="w-full whitespace-normal">
            {{ $t('noTags') }}
          </div>
        </template>
      </BaseSelect>
      <div class="col-span-2 grid grid-cols-2 col-gap-12">
        <VueCtkDateTimePicker v-model="form.date"
                              id="transaction-date"
                              format="YYYY-MM-DD"
                              formatted="DD.MM.YYYY"
                              :locale="$i18n.locale"
                              :label="$t('dateLabel')"
                              :auto-close="true"
                              :only-date="true"
                              :no-clear-button="true"
                              :no-button="true"
                              color="#2D4C5E"/>
        <VueCtkDateTimePicker v-if="current_space.data.time_enabled"
                              id="transaction-time"
                              v-model="form.time"
                              format="HH:mm"
                              formatted="HH:mm"
                              :locale="$i18n.locale"
                              :label="$t('timeLabel')"
                              :only-time="true"
                              :no-clear-button="true"
                              :no-button="true"
                              color="#2D4C5E"/>
      </div>
<!--      <BaseCheckbox :checked="form.off_report"-->
<!--                    size="sm"-->
<!--                    class="-mt-5"-->
<!--                    @change="form.off_report = !form.off_report">-->
<!--        <span class="text-sm">{{ $t('isReportText') }}</span>-->
<!--      </BaseCheckbox>-->
<!--      <BaseCheckbox :checked="form.off_budget"-->
<!--                    size="sm"-->
<!--                    class="-mt-5"-->
<!--                    @change="form.off_budget = !form.off_budget">-->
<!--        <span class="text-sm">{{ $t('isBudgetText') }}</span>-->
<!--      </BaseCheckbox>-->
      <div class="col-span-2 flex items-center">
        <BaseButton @click="saveChanges"
                    class="mr-8"
                    style="width: 255px;"
                    :loading="submitted"
                    theme="gray">
          {{ $t('saveChanges') }}
        </BaseButton>
        <BaseButton @click="$emit('cancel')"
                    style="width: 140px;"
                    :loading="submitted"
                    theme="white">
          {{ $t('cancel') }}
        </BaseButton>
        <ArchiveBtn class="ml-auto"
                    @confirm="removeOperation"
                    :submitted="submitted">
          <template v-slot:text>
            {{ $t('remove') }}
          </template>
        </ArchiveBtn>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import {decimal, required} from "vuelidate/lib/validators";
import ValueInput from "@/components/UI/BaseInput/ValueInput";
import AccountsSelect from "@/components/UI/BaseSelect/AccountsSelect";
import BaseSelect from "@/components/UI/BaseSelect/BaseSelect";
import BaseButton from "@/components/UI/BaseButton";
import BaseTextarea from "@/components/UI/BaseTextarea";
import BaseCheckbox from "@/components/UI/BaseCheckbox";
import IconTrash from "@/components/icons/IconTrash";
import TransactionEditModalFormRemoveButton
  from "@/components/common/Transaction/TransactionEditModal/TransactionEditModalFormRemoveButton";
import ArchiveBtn from "@/components/UI/ArchiveBtn";

export default {
  name: "TransactionEditFormTransfer",
  components: {
    ArchiveBtn,
    TransactionEditModalFormRemoveButton,
    IconTrash, BaseCheckbox, BaseTextarea, BaseButton, BaseSelect, AccountsSelect, ValueInput
  },
  props: {
    transaction_item: {
      required: true
    },
    transaction_options: {
      required: true
    },
    submitted: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      form: {
        sum: null,
        sum_to: null,
        fee: null,
        account: null,
        account_to: null,
        expenseCategory: null,
        comment: '',
        tags: [],
        date: null,
        time: null,
        // off_report: false,
        // off_budget: false
      }
    }
  },
  validations: {
    form: {
      sum: {
        required,
        decimal,
      },
      sum_to: {
        required: required,
        decimal,
      },
      fee: {
        decimal,
      }
    }
  },
  computed: {
    ...mapState('space', ['current_space']),
    ...mapState('space/expenses', ['expenses']),
    ...mapState('space/tags', ['tags_list']),
    ...mapState('space/accounts', ['accounts']),
    ...mapGetters('space/accounts', ['accounts_by_groups']),
    ...mapGetters('space/expenses', ['expenses_by_groups']),
    accountTransfer() {
      return this.accounts.data.filter(i => i.id !== this.form.account.id);
    },
    accountTransferGroups() {
      return this.accounts_by_groups.map(group => {
        return {
          ...group,
          childs: group.childs.filter(acc => acc.id !== this.form.account.id)
        }
      })
    }
  },
  methods: {
    ...mapActions('space/tags', ['createTag']),
    ...mapActions('cabinet/currencies', ['exchangeValues']),
    addTag(val) {
      const tag = {title: val, space_id: this.current_space.data.id};
      this.createTag(tag).then(res => {
        if (res.body.success) {
          this.form.tags.push(res.body.data);
          this.$store.commit('space/tags/pushTag', res.body.data);
        }
      })
    },
    handleFee() {
      const {account, sum} = this.form;

      if (!!account && account.commission && !!sum) {
        if (account.commission_type === 1) {
          const s = sum * 100,
              f = +account.commission_value;
          this.form.fee = +(s * f / 10000).toFixed(account.currency.decimals);
        } else {
          this.form.fee = +account.commission_value;
        }
      } else {
        this.form.fee = null;
      }
    },
    handleTransferCurrency() {

      if (!this.form.account || !this.form.account_to) return
      if (!this.form.account_to.currency.id) return
      if (!this.form.sum) {
        this.form.sum_to = null;
        return
      }

      let val = this.form.sum,
          curr_from = this.form.account.currency.id,
          curr_to = this.form.account_to.currency.id;
      if (curr_from === curr_to) {
        this.form.sum_to = val
      } else {
        let data = {
          currency_from: curr_from,
          currency_to: curr_to,
          sum: val,
          date_time: this.current_space.data.time_enabled ?
              `${this.form.date} ${this.form.time}:00`
              :
              `${this.form.date} ${this.$moment().format('HH:mm')}:00`,
          timezone: this.$moment.tz.guess()
        }
        this.exchangeValues(data).then((res) => {
          if (res.body.success) {
            this.form.sum_to = res.body.data.toFixed(this.form.account_to.currency.decimals);
          }
        });
      }
    },
    setFields(transaction) {
      const {transfer} = transaction;
      this.form.account = transfer.expense.account;
      this.form.account_to = transfer.income.account;
      this.form.sum = !!transfer.expense.commission ?
          transfer.expense.sum - transfer.expense.commission :
          transfer.expense.sum;
      this.form.sum_to = transfer.income.sum;
      this.form.sum = this.form.sum.toFixed(transfer.expense.account.currency.decimals)
      this.form.sum_to = this.form.sum_to.toFixed(transfer.income.account.currency.decimals)
      this.form.fee = !!transfer.expense.commission ? transfer.expense.commission : 0;
      this.form.expenseCategory = transfer.expense.expense;
      this.form.comment = !!transaction.comment ? transaction.comment : '';
      this.form.tags = transaction.tags;

      this.form.date = this.$moment.unix(transaction.date).format('YYYY-MM-DD');
      this.form.time = this.$moment.unix(transaction.date).format('HH:mm');

      // this.form.off_report = transaction.off_report
      // this.form.off_budget = transaction.off_budget
    },
    prepareData(payload) {
      let data = {}

      data.id = this.transaction_item.transfer_id
      data.from_id = payload.account.id
      data.to_id = payload.account_to.id
      data.sum_from = payload.account.commission_type !== null ?
          (+payload.sum + +payload.fee) : +payload.sum;
      data.sum_to = +payload.sum_to
      data.category_id = (this.transaction_options.category && !!payload.expenseCategory) ? payload.expenseCategory.id : '';


      data.date_time = this.current_space.data.time_enabled ?
          `${payload.date} ${payload.time}:${this.$moment().format('ss')}` :
          `${payload.date} ${this.$moment().format('HH:mm:ss')}`;
      data.timezone = this.$moment.tz.guess();
      data.comment = this.transaction_options.comment ? payload.comment : '';
      data.tag_ids = this.transaction_options.tags ? payload.tags.map(i => i.id) : [];
      // data.off_report = this.form.off_report;
      // data.off_budget = this.form.off_budget;

      return data;
    },
    saveChanges() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        const data = this.prepareData(this.form);
        this.$emit('updateTransfer', data)
      }
    },
    removeOperation() {
      this.$emit('removeTransfer', this.transaction_item.transfer_id)
    }
  },
  watch: {
    transaction_item: {
      immediate: true,
      handler(newVal) {
        if (!!newVal) {
          this.setFields(newVal)
        }
      }
    },
    'form.sum': {
      handler() {
        this.handleFee();
        this.handleTransferCurrency();
      }
    },
    'form.account': {
      handler(val, oldVal) {
        this.handleFee()
        this.handleTransferCurrency();

        if (!!this.form.account_to) {
          //reset destination account if selected the same
          if (this.form.account.id === this.form.account_to.id) {
            this.form.account_to = oldVal;
          }
        }
      }
    },
    'form.account_to': {
      handler: 'handleTransferCurrency'
    },
  },
  i18n: {
    messages: {
      en: {
        fieldRequired: 'Field is required',
        sum: 'Sum',
        sum_to: 'Received amount',
        commission: 'Commission',
        accountFrom: 'From account',
        accountTo: 'To account',
        categoryExpense: 'Expense category',
        comment: 'Comment',
        tags: 'Tags',
        tagCreateNew: 'Create new',
        noTags: 'You have no tags, enter name to create the new tag',
        // isReportText: 'ignore in reports',
        // isBudgetText: 'ignore in budgets',
        dateLabel: 'Transaction date',
        timeLabel: 'Transaction time',
        saveChanges: 'Save changes',
        cancel: 'Cancel',
        remove: 'Delete',
      },
      ru: {
        fieldRequired: 'Поле обязательно',
        sum: 'Сумма',
        sum_to: 'Поступит',
        commission: 'Комиссия',
        accountFrom: 'Со счета',
        accountTo: 'На счет',
        categoryExpense: 'Категория расхода',
        comment: 'Комментарий',
        tags: 'Теги',
        tagCreateNew: 'Добавить новый',
        noTags: 'У вас нет тегов, введите название первого тега',
        // isReportText: 'не учитывать сумму в отчетах',
        // isBudgetText: 'не учитывать сумму в бюджетах',
        dateLabel: 'Дата операции',
        timeLabel: 'Время операции',
        saveChanges: 'Сохранить изменения',
        cancel: 'Отмена',
        remove: 'Удалить',
      }
    }
  }
}
</script>